import { ISegment } from '@/interfaces/Behavior';

export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c == 'x' ? r : (r & 0x3 | 0x8);

    return v.toString(16);
  });
};

export const getUUIDWeight = (uuid: string) => {
  let hash = 0;
  let i = 0;

  while (i < uuid.length) {
    hash = ((hash << 5) - hash + uuid.charCodeAt(i++)) << 0;
  }

  return (hash + 2147483647) % 100 / 100;
};

export const defineSegmentByWeight = (p: number, segments: ISegment[]) => {
  let weight = 0;
  for (const segment of segments) {
    weight += segment.weight;

    if (p < weight) {
      return segment;
    }
  }
};